export function setNormalizedTokenClaims(decodedToken) {
  decodedToken['dexf_service'] = getNormalizedTokenClaim(decodedToken['dexf_service']);
  decodedToken['dexf_data'] = getNormalizedTokenClaim(decodedToken['dexf_data']);

  return decodedToken;
}

export function getNormalizedTokenClaim(decodedTokenClaim) {
  if (!decodedTokenClaim) return '';

  let normalizedClaims = decodedTokenClaim;

  // If claim contains the pipe, it means it needs to be parsed/flatten
  if (decodedTokenClaim.includes('|')) {
    const normalized = [];
    // split the claim in the queue of privileges
    let queue = decodedTokenClaim.split(",");

    // The idea is to push and flatten privileges till all are normalized
    while (queue.length > 0) {
      const elem = queue.shift();

      if (elem.includes('|')) {
        const newElements = flattenElement(elem);
        for (let i = 0; i < newElements.length; i++) {
          normalized.push(newElements[i]);
        }
      }
      else {
        normalized.push(elem);
      }
    }
    // rejoin normalized privileges back to claims
    normalizedClaims = normalized.join(",");
  }

  return normalizedClaims;
}

function flattenElement(elem) {
  let normalizedObjLevels = [];
  let objLevels = elem.split(":");

  // if there is no privileges, return nothing
  if (objLevels.length < 1) {
    return [];
  }
  // First we seed container with first element:  We safely assume that
  // the first element does not contain any pipe character since it is the highest level
  normalizedObjLevels.push(objLevels.shift());

  while (objLevels.length > 0) {
    const obj = objLevels.shift();
    let tmpNormalizedObjLevels = [];

      const subObjects = obj.split('|');
      // clone everything we have so far by number of split objects and append new objects
      for (let i = 0; i < normalizedObjLevels.length; i++) {
        for (let j = 0; j < subObjects.length; j++) {
          tmpNormalizedObjLevels.push(normalizedObjLevels[i] + ":" + subObjects[j]);
        }
      }
      normalizedObjLevels = tmpNormalizedObjLevels.slice();

  }
  return normalizedObjLevels;
}

